<template>
  <div class="organizations-table">
    <template v-if="activeSearch">
      <span>Búsqueda Actual: </span><strong>{{ activeSearch }}</strong>
    </template>
    <template v-else>
      <span>Mostrando todas las organizaciones</span>
    </template>
    <table class="table table-hover">
      <thead>
        <tr>
          <th width="1" nowrap>
            Estado
          </th>
          <th v-if="source === 'midas'">
            Codigo
          </th>
          <th>Nombre</th>
          <th>Rut</th>
          <th width="1">
            Usuarios
          </th>
          <th v-if="userCanManageOrganizations" width="1" />
        </tr>
      </thead>
      <tbody v-if="organizations.length">
        <tr v-for="organization in filteredOrganizations" :key="`organization-key-${organization.uuid}`">
          <td>
            <el-tag :type="organizationIsActive(organization) ? 'success' : 'danger'">
              {{ organizationIsActive(organization) ? 'Activa' : 'Inactiva' }}
            </el-tag>
          </td>
          <td v-if="source === 'midas'">
            <router-link :to="organizationDetailsRoute(organization)">
              {{ organization.code }}
            </router-link>
          </td>
          <td>
            <router-link :to="organizationDetailsRoute(organization)">
              {{ organization.name }} - Local: {{organization.local}} 
            </router-link>
          </td>
          <td nowrap>
            <router-link :to="organizationDetailsRoute(organization)">
              {{ organization.rut }}
            </router-link>
          </td>
          <td align="center">
            <i class="fas fa-user" /> {{ organizationUserCount(organization) }}
          </td>
          <td v-if="userCanManageOrganizations" nowrap>
            <button class="btn btn-sm btn-success" @click.prevent="handleClickEditOrganization(organization)">
              Editar
            </button>
            <button class="btn btn-sm btn-danger" @click.prevent="handleClickDeleteOrganization(organization)">
              Eliminar
            </button>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr class="table-warning text-center">
          <td colspan="5">
            No hay organizaciones disponibles
          </td>
        </tr>
      </tbody>
    </table>
    <el-pagination
      background
      layout="prev, pager, next"
      :hide-on-single-page="true"
      class="text-center"
      :current-page="pagination.page"
      :total="pagination.total"
      :page-size="pagination.perPage"
      @current-change="handlePaginationChange" />
    <el-dialog
      :width="dialogWidth"
      :title="`Nueva Organización`"
      :visible="organizationToEdit !== null"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleCloseOrganizationDialog">
      <organization-form
        v-if="organizationToEdit"
        :organization="organizationToEdit"
        :type="type"
        :source="source"
        @organization-saved="handleOrganizationSaved" />
    </el-dialog>
  </div>
</template>

<script>
import OrganizationForm from '@/components/user/OrganizationForm';
import _get from 'lodash/get';

export default {
  name: 'OrganizationTable',
  components: { OrganizationForm },
  props: {
    organizations: {
      type: Array,
      required: true
    },
    pagination: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    msg: {
      type: String,
      default: ''
    },
    source: {
      type: String,
      default: 'midas'
    },
    listOnly: {
      type: Boolean,
      default: false
    },
    activeSearch: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      organizationToEdit: null
    };
  },
  computed: {
    userCanManageOrganizations() {
      return this.$store.getters.hasRole('admin') && !this.listOnly;
    },
    dialogWidth() {
      return this.$store.getters.windowWidth < 992 ? '80%' : '50%';
    },
    filteredOrganizations() {
      const search = this.msg.toLowerCase();
      return this.organizations.filter(organization => {
        return organization.name.toLowerCase().indexOf(search) >= 0;
      });
    }
  },
  methods: {
    organizationIsActive(organization) {
      return organization.status === 'active';
    },
    organizationUserCount(organization) {
      return _get(organization, '__meta__.users_count', 0);
    },
    handleClickDeleteOrganization(organization) {
      this.$emit('delete-organization', organization);
    },
    handleClickEditOrganization(organization) {
      this.organizationToEdit = JSON.parse(JSON.stringify(organization));
    },
    organizationDetailsRoute(organization) {
      return `/organizations/${this.source}/${organization.uuid}`;
    },
    handleClickAddOrganization() {
      this.organizationToEdit = {
        status: 'active'
      };
    },
    handleOrganizationSaved(organization) {
      this.$message({
        type: 'success',
        message: 'Organización guardada'
      });
      this.$emit('organization-saved', organization);
      this.handleCloseOrganizationDialog();
    },
    handleCloseOrganizationDialog() {
      this.organizationToEdit = null;
    },
    handlePaginationChange(page) {
      this.$emit('page-change', page);
    }
  }
};
</script>

<style lang="scss">
.organizations-table {
  td:last-child:not(:first-child) {
    button {
      margin-left: $--spacing-1;
    }
  }
}
</style>
|
